import { render, staticRenderFns } from "./PersonTokenValidation.vue?vue&type=template&id=b2378778&"
import script from "./PersonTokenValidation.vue?vue&type=script&setup=true&lang=js&"
export * from "./PersonTokenValidation.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports